import { render, staticRenderFns } from "./CandidateStatusUpdateForm.vue?vue&type=template&id=9dcc954c&"
import script from "./CandidateStatusUpdateForm.vue?vue&type=script&lang=js&"
export * from "./CandidateStatusUpdateForm.vue?vue&type=script&lang=js&"
import style0 from "./CandidateStatusUpdateForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports